import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/icon-call.svg'
import _imports_1 from '@/assets/icons/icon-conversation-bubble.jpg'


const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "modal-body scroll-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "prefer-text"
}
const _hoisted_5 = { class: "content-options" }
const _hoisted_6 = { class: "content-call-back-wr" }
const _hoisted_7 = { class: "content-call-back" }
const _hoisted_8 = {
  key: 0,
  class: "line-options-wr"
}
const _hoisted_9 = { class: "content-message-wr" }
const _hoisted_10 = { class: "content-message" }
const _hoisted_11 = {
  key: 1,
  class: "content-options-buttons"
}
const _hoisted_12 = { class: "content-button-request" }
const _hoisted_13 = { class: "content-button-request end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["Modal"], {
      isOpen: $setup.props.isOpen,
      onClose: $setup.onClose,
      classes: ['options-quote-modal']
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString($setup.isDesktop ? "Got a question? We’re here to help!" : "Let us know how you’d prefer to get answers to your questions"), 1),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "line" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          ($setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Let us know how you’d prefer to get answers to your questions"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "icon-call-wr",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (!$setup.isDesktop ? $setup.onCall() : null))
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("img", {
                    class: "icon-call",
                    src: _imports_0
                  }, null, -1)
                ]))]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-call" }, "Select a date and time and we’ll give you a call.", -1))
              ])
            ]),
            ($setup.isDesktop)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("div", { class: "line" }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "icon-message-wr",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (!$setup.isDesktop ? $setup.onMessage() : null))
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("img", {
                    class: "icon-message",
                    src: _imports_1
                  }, null, -1)
                ]))]),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-message" }, "Send us a message and we’ll get back to you as soon as possible.", -1))
              ])
            ])
          ]),
          ($setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode($setup["ContactUsLink"], {
                    class: "request",
                    animationName: "''",
                    toContactUsForm: false,
                    linkCalendly: $setup.CALENDLY_BUILD_LINK,
                    text: 'Request a call back',
                    isButtonCallBackModal: true,
                    onCloseModal: _cache[2] || (_cache[2] = ($event: any) => ($setup.emits('close')))
                  }, null, 8, ["linkCalendly"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: "button default primary request",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.onMessage()))
                  }, "Send a message")
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode($setup["BuilderRequestMessageSendModal"], {
      isOpen: $setup.isOpenedModalRequestMessage,
      lot: $setup.props.lot,
      onClose: $setup.onClose,
      onSend: $setup.onSend
    }, null, 8, ["isOpen", "lot"])
  ], 64))
}